module.exports = {
      id: "lease-aruba-usage",
      viewBox: "0 0 141.7 141.7",
      url: __webpack_public_path__ + "img/symbols.b783b922d187f028e7dcd3736258c276.svg#lease-aruba",
      toString: function () {
        return this.url;
      }
    }